<template>
<div class="newcoupon">
  <img src="@/assets/images/newcouponbg.png" alt="" class="topbg" @click="gorent()">
  <div class="detail">
    <div class="tit">活动规则</div>
    <p>活动期间新用户注册将自动发送到用户账户。</p>
    <p>1、新用户注册成功，即享200元优惠券礼包(包括100元首租专享券一张和50元、30元、20元优惠券各一张），自领券日起180天有效。</p>
    <p>2、100元首租专享券，限首单且租满2天及以上使用，首日租金低于100元时，减免首日租金。</p>
    <p>3、50元、30元、20元优惠券可在下次下单时使用，50元优惠券租期≥3天可用，30元优惠券租期≥2天可用，20元优惠券不限租期。</p>
    <p>4、优惠券不可叠加使用，不与其他优惠同享。</p>
  </div>

</div>
</template>
<script>
import { orderSource } from "@/utils/env";
export default {
  name: "newcoupon",
  data() {
    return {
     userID:'',
     name:''
    };
  },
  props: [],
  created(){
    this.name = this.$route.query.name;
    // console.log(this.$route.query)
  },
  methods: {
    gorent(){
      if(orderSource==17){
        window.webkit.messageHandlers.goHome.postMessage(null);
      }else if(orderSource==16){
        dfpanda.goHome();
      }
    }
  }
};
</script>

<style lang="scss" scoped type="text/scss">
.newcoupon {
  position: absolute;
  background:#FFFDFB;
  top:0;
  display: flex;
  flex-direction: column;
  align-items: center;
  .topbg{
    width:100%;
  }
  .detail{
    width:640px;
    padding-bottom:50px;
    color:#434343;
    .tit{
      text-align: center;
      font-size: 26px;
      padding:20px;
    }
    p{
      font-size: 22px;
      line-height: 40px;
    }
  }

}
</style>

